import { useState, useEffect, useLayoutEffect } from 'react';
import { useTable, usePagination,useExpanded } from 'react-table';
import { motion } from "framer-motion";

// import {
//     showNotiLoader,
//     hideNotiLoader,
//     showNotiLoaderError
// } from '../../antd-loader';

import './index.css';
import LoadingSpinner from '../../spinner/Loading';
import React from 'react';

//data format
interface PropsData {
    headerStyle?: any;
    columns?: any[];
    data?: any[];
    rowClick?: any;
    currentPage?: number|any;
    totalRecords?: number|any;
    pageSize?: number;
    pageChange?: any;
    hasPagination?: boolean;
    selectedRows?: any; //active style set to selected rows
    fetchExpandedData?: (row: any) => Promise<JSX.Element>;//fetch expanded data and return renderable JSX,
    size?: string//small,normal;
    template?: string
    loading?: boolean;
    borderSeparate?: boolean;
    Footer?: any;
    CustomFooter?: any;
    onPageSizeChanged?: any;
    ableChangePageSize?: boolean;
}



const Index = ({
    headerStyle,
    columns,
    data,
    rowClick,
    hasPagination,
    currentPage,
    totalRecords,
    pageSize,
    pageChange,
    selectedRows,
    fetchExpandedData,
    size ="normal",
    template="",
    loading= false,
    borderSeparate=false,
    Footer,
    CustomFooter,
    onPageSizeChanged,
    ableChangePageSize = false
}: PropsData) => {
    // const _pageSize = pageSize || 10;
    let pageRange = 5;

    const [visiblePages, setVisiblePages] = useState([]);
    const [tableTotalPage, setTableTotalPage] = useState(0);
    const [expandedRows, setExpandedRows] = useState<{ [key: string]: JSX.Element | null }>({});
    const [expandedData, setExpandedData] = useState<{ [key: string]: JSX.Element | null }>({});
    const [expanded, setExpanded] = useState<{ [key: string]: boolean }>({}); // State for expanded rows

    const [_pageSize, set_pageSize] = useState(pageSize || 10);

    // const [startLoad, setStartLoad] = useState(false);
    // useEffect(() => {
    //     if (startLoad == true) showNotiLoader();
    // }, [startLoad]);

    // const [rowSelection, setRowSelection] = useState({});


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        canPreviousPage,
        canNextPage,
        gotoPage,
        nextPage,
        previousPage,
        // Get the state from the instance
        state: { pageIndex }
        //pageSize,
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageIndex: currentPage - 1 || 0, //first page
                pageSize: _pageSize
            },
            state: {
                //rowSelection,
                pageIndex: currentPage - 1 || 0 //first page
            },
            //onRowSelectionChange: setRowSelection,
            manualPagination: true, // Tell the usePagination
            // hook that we'll handle our own data fetching
            // This means we'll also have to provide our own
            // pageCount.
            pageCount: Math.ceil((totalRecords || 0) / _pageSize)
        },
        useExpanded ,
        usePagination,
    );

    useEffect(() => {
        //  alert('change');
    }, [pageIndex]);

    useEffect(() => {
        if (totalRecords) {
            getVisiblePages(pageIndex, _pageSize, totalRecords || 0);
            // setCurrentPage(pagination.currentPage);
        }
    }, [data]);

    const getVisiblePages = (pageIndex:any, _pageSize:any, total:any) => {
        // console.log('getVisiblePages');
        // console.log(total);
        // console.log('pageIndex', pageIndex);
        //  let currentPage = pageIndex + 1;
        let countPage = Math.ceil(total / _pageSize);
        setTableTotalPage(countPage);

        if (pageRange % 2 == 0) pageRange++;
        let distance:any = pageRange / 2;

        let toLeft = parseInt(distance);
        let toRight = parseInt(distance);

        // console.log('toLeft', toLeft);
        // console.log(currentPage);
        // console.log('countPage', countPage);

        let arr:any = [];
        //move left
        for (var i = 0; i < toLeft; i++) {
            let goLeft = toLeft - i;
            // console.log('count left');
            //console.log(pageIndex - goLeft);
            if (pageIndex - goLeft >= 0) {
                // console.log('added');
                arr.push(pageIndex - goLeft);
            } else {
                toRight++;
            }
        }

        arr.push(pageIndex);
        //move right
        for (var z = 0; z < toRight; z++) {
            let goRight = z + 1;
            if (pageIndex + goRight < countPage) {
                arr.push(pageIndex + goRight);
            }
        }

        //console.log(arr);
        setVisiblePages(arr);
    };

    function handlePageRedirect(pageIndex:any) {
        // alert(pageIndx);
        gotoPage(pageIndex);
        if (pageChange) {
            // setStartLoad(true);
            // showNotiLoader();
            pageChange(pageIndex + 1);
        }
    }


    const handleExpandClick = async (row:any) => {
        //console.log("handleExpandClick",row, expanded[row.id]);
       
        let rowId = row.id
        let renderExpandedData = <></>
        if(fetchExpandedData){
            //trigger only when expand row
            if(!expanded[row.id]){
                const elements = await fetchExpandedData(row.original);
                renderExpandedData = elements;
            }
            
        }
      
        setExpandedData((prevExpandedData) => ({
            ...prevExpandedData,
            [rowId]: renderExpandedData,
        }));

        setExpandedRows((prevExpandedRows) => ({
            ...prevExpandedRows,
            [rowId]: !prevExpandedRows[rowId],
        }));

        setExpanded((prevExpanded) => ({
            ...prevExpanded,
            [rowId]: !prevExpanded[rowId], // Toggle the expanded state
        }));
    };


    // console.log('currentPage', currentPage);
    // console.log('pageIndex', pageIndex);

    const getWidthFromConfig = (columnId:any) => {
        if(!columns) return 0;

        const column = columns.find((column:any) => column.accessor === columnId);
        return column?.width;
    }

    return (
        <>
            <div className={"react-table-container "} style={{ overflow: 'auto' }}>
                <table
                    className={"react-table "+size+" "+(borderSeparate?" separate ":"")+(template?template:" ")} 
                    {...getTableProps()}
                    cellSpacing="0"
                    cellPadding="0"
                >
                    <thead style={headerStyle ? headerStyle : null}>
                 
                        {headerGroups.map((headerGroup:any) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {
                                    fetchExpandedData && <th  
                                    style={{
                                        width: "10px"
                                    }}></th>
                                }
                                {headerGroup.headers.map((column:any) => {
                                    // console.log("columns",columns)
                                    // console.log("column",column)
                                    return (
                                        <th {...column.getHeaderProps()}
                                            rowSpan={`${column.rowSpan ?? 1}`}
                                            style={column.displayNone ? { display: 'none' } : {
                                                width: getWidthFromConfig(column.id) || 'auto',
                                            }}
                                        >
                                            {/* {JSON.stringify(column.getHeaderProps())} */}
                                             {column.render('Header')}
                                        </th>
                                    )
                                })}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {loading ? (
                         <tr className='no-hover' >
                            <td
                                colSpan={headerGroups[0]?.headers.length+1}
                                key={"loading-row"}
                            >
                                <div className='d-flex justify-content-center align-items-center' style={{minHeight:"200px"}}>
                                    <LoadingSpinner fontSize={50}/>
                                </div>
                            </td>
                        </tr>
                        ) 
                        :
                        <>
                            {rows.map((row:any, i:number) => {
                                // console.log(headerGroups);
                                prepareRow(row);
                                return (
                                    <React.Fragment key={row.id}>
                                        <motion.tr
                                            key={i}
                                            className={
                                                ' ' +
                                                (rowClick ? ' cursor-pointer ' : '') +
                                                (selectedRows && selectedRows[i]
                                                    ? ' selected '
                                                    : '')
                                            }
                                            {...row.getRowProps({
                                                initial: "hidden",
                                                animate: "visible",
                                                variants:{
                                                    visible: { opacity: 1 },
                                                    hidden: { opacity: 0 }
                                                },
                                                transition: { ease: "easeIn", duration: 0.25 },
                                                exit: {
                                                opacity: 0,
                                
                                                transition: { ease: "easeOut", duration: 0.25 }
                                                }
                                            })}
                                            {...(rowClick && {
                                                onClick: () => rowClick(row)
                                            })}
                                        >
                                            {
                                                fetchExpandedData &&
                                                <td className='' style={{
                                                    width: "10px"
                                                }}>
                                                    <div className={" expand-icon "+(expanded[row.id] ? 'expanded' : '')} onClick={() => handleExpandClick(row)}>
                                                        
                                                        </div>
                                                    
                                                </td>
                                            }
                                            
                                            {row.cells.map((cell:any) => {
                                                return (
                                                    <td {...cell.getCellProps()}>
                                                        {cell.render('Cell')}                                            
                                                    </td>
                                                );
                                            })}
                                            
                                        </motion.tr>
                                        <tr key={"expand-i"} className={`expanded-row ${expanded[row.id] ? '' : 'hidden'}`}>
                                            {expandedRows[row.id] && (
                                            
                                                <td colSpan={columns && ( columns.length +1 )}>
                                                        {/* Render the expanded row content here */}
                                                    <div >
                                                        {expandedData[row.id] || <p>Loading...</p>}
                                                    </div>
                                                </td>
                                            
                                            )}
                                        </tr>
                                    
                                    </React.Fragment>
                                );
                            })}  
                            <tr>
                                {rows.length == 0 && (
                                    <td
                                        colSpan={headerGroups[0]?.headers.length+1}
                                        className="no-data "
                                    >
                                       <div className='h-100 d-flex justify-content-center align-items-center'>
                                            No Data
                                       </div>
                                    </td>
                                )}
                            </tr>
                        </>
                        }
                       
                    </tbody>
                    {
                        Footer &&
                        <tfoot className='footer'>
                            <tr >
                                <td colSpan={headerGroups[0]?.headers.length+1}>{Footer}</td>
                        
                            </tr>
                        </tfoot>
                    }
                     {
                        CustomFooter &&
                        <tfoot className='footer'>
                           {CustomFooter}
                        </tfoot>
                    }
                </table>

                {hasPagination == true && rows.length > 0 && (
                    // pagination component

                    <div className="pagination-container">
                        <div className="page-info">
                            <span>
                                Showing {(currentPage - 1) * _pageSize + 1} to{' '}
                                {currentPage * _pageSize > totalRecords
                                    ? totalRecords
                                    : (pageIndex + 1) * _pageSize}{' '}
                                of {totalRecords} entries
                            </span>
                            {
                                ableChangePageSize &&
                                <select
                                    id="pageSize"
                                    value={pageSize}
                                    onChange={(e) => {
                                        const newSize = parseInt(e.target.value, 10);
                                        set_pageSize(newSize);

                                        if(onPageSizeChanged){
                                            onPageSizeChanged(newSize)
                                        }
                                        // setCurrentPage(1); // reset to first page
                                        // optionally refetch data here if needed
                                    }}
                                >
                                    {[10, 20, 50, 100].map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                            }
                            
                        </div>
             
                        <div className="pagination-list">
                            <button
                                className="previous-btn"
                                onClick={
                                    () => handlePageRedirect(currentPage - 2) //previous pageIndex
                                }
                                disabled={!canPreviousPage}
                            >
                                Previous
                            </button>
                            {pageIndex > 0 && pageIndex >= pageRange - 1 && (
                                <>
                                    <div
                                        className={'pagination-btn '}
                                        onClick={() => handlePageRedirect(0)}
                                    >
                                        1
                                    </div>
                                    ...
                                </>
                            )}
                            {visiblePages &&
                                visiblePages.map((page, index, array) => {
                                    return (
                                        <div
                                            key={index}
                                            className={
                                                'pagination-btn ' +
                                                (currentPage - 1 == page
                                                    ? ' current '
                                                    : '')
                                            }
                                            onClick={() =>
                                                handlePageRedirect(page)
                                            }
                                        >
                                            {page + 1}
                                        </div>
                                    );
                                })}
                            {currentPage <
                                tableTotalPage - (pageRange / 2 + 1) &&
                                tableTotalPage > 1 && (
                                    <>
                                        {' '}
                                        ...
                                        <div
                                            className={'pagination-btn '}
                                            onClick={() =>
                                                handlePageRedirect(
                                                    tableTotalPage - 1
                                                )
                                            }
                                        >
                                            {tableTotalPage}
                                        </div>
                                    </>
                                )}
                            <button
                                className="next-btn"
                                onClick={
                                    () => handlePageRedirect(currentPage) // next pageIndex
                                }
                                disabled={!canNextPage}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Index;
